import lengthEndAdornment from "constants/lenghtEndAdornment";
import CreateProductAttributesFormFields from "./CreateProductAttributesFormFields";

const fields = [
  {
    name: "applicationRate",
    label: "Material Application Depth",
    inputProps: { ...lengthEndAdornment },
  },
];

export default function GradingForm() {
  return <CreateProductAttributesFormFields fields={fields} />;
}
